import React from 'react';
import { motion } from 'framer-motion';

const WorkflowShowcase = () => {
  return (
    <section
      data-testid="workflow-showcase"
      className="relative py-16 lg:py-24 px-4 sm:px-6"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-10 lg:mb-16"
        >
          <span className="uppercase tracking-[0.15em] sm:tracking-[0.2em] text-xs font-semibold text-emerald-400 mb-4 block">
            Real Workflow Examples
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold font-outfit text-white mb-4">
            Build Complex <span className="text-gradient">Automations</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-sm sm:text-base">
            Drag, drop, and connect. Create sophisticated AI workflows without writing code.
          </p>
        </motion.div>

        {/* Workflow Images Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12">
          {/* First Workflow */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative group"
          >
            <div className="absolute -inset-2 bg-gradient-to-br from-emerald-500/20 to-cyan-500/10 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <div className="relative rounded-xl sm:rounded-2xl overflow-hidden border border-emerald-500/20 bg-slate-950/50 backdrop-blur-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_reasoning-platform/artifacts/ytdnns9l_image.png"
                alt="AI Chat Processing Pipeline"
                className="w-full h-auto"
              />
            </div>
            <div className="mt-3 sm:mt-4 text-center">
              <h3 className="text-lg sm:text-xl font-bold text-white font-outfit mb-1 sm:mb-2">AI Chat Processing</h3>
              <p className="text-slate-400 text-xs sm:text-sm">Multi-model routing with OpenAI, Opus, Gemini & Perplexity</p>
            </div>
          </motion.div>

          {/* Second Workflow */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="relative group"
          >
            <div className="absolute -inset-2 bg-gradient-to-br from-cyan-500/20 to-purple-500/10 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <div className="relative rounded-xl sm:rounded-2xl overflow-hidden border border-cyan-500/20 bg-slate-950/50 backdrop-blur-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_reasoning-platform/artifacts/yake00s7_image.png"
                alt="Automated User Onboarding"
                className="w-full h-auto"
              />
            </div>
            <div className="mt-3 sm:mt-4 text-center">
              <h3 className="text-lg sm:text-xl font-bold text-white font-outfit mb-1 sm:mb-2">User Onboarding</h3>
              <p className="text-slate-400 text-xs sm:text-sm">Conditional branching with Slack, Jira & Microsoft Entra ID</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WorkflowShowcase;
